import initialState from '../store/initialState'
import accountsTypes from '../constants/accountsTypes'

const { M } = window
const { toast } = M

export default function accountsReducer(state = initialState.accounts, action) {
  //console.log(action.type)
  switch (action.type) {

    case accountsTypes.reset_errors: {
      return {
        ...state,
        errors: []
      }
    }

    // INDEX
    case accountsTypes.index.request: {
      return {
        ...state,
        errors: [],
        fetching: true,
        fetched: false
      }
    }

    case accountsTypes.index.success: {
      return {
        ...state,
        errors: [],
        fetching: false,
        fetched: true,
        accounts: action.payload.accounts,
        pagination: action.payload.pagination
      }
    }

    case accountsTypes.index.failure: {
      toast({
        html: action.payload
      })
      return {
        ...state,
        errors: action.payload,
        fetching: false,
        fetched: false
      }
    }

    // AUTOCOMPLETE
    case accountsTypes.autocomplete.request: {
      return {
        ...state,
        errors: [],
        fetching: true,
        fetched: false
      }
    }

    case accountsTypes.autocomplete.success: {
      return {
        ...state,
        errors: [],
        fetching: false,
        fetched: true,
        query: action.payload.query,
        account_names: action.payload.account_names,
        account_data: action.payload.account_data
      }
    }

    case accountsTypes.autocomplete.filter_success: {
      return {
        ...state,
        errors: [],
        fetching: false,
        fetched: true,
        filter_query: {
          query: action.payload.query,
          account_names: action.payload.account_names,
          account_data: action.payload.account_data
        }
      }
    }

    case accountsTypes.autocomplete.failure: {
      toast({
        html: "Error fetching account data"
      })
      return {
        ...state,
        errors: [],
        fetching: false,
        fetched: false
      }
    }

    case accountsTypes.autocomplete.reset: {
      return {
        ...state,
        query: '',
        errors: [],
        account_names: {},
        account_data: {}
      }
    }

    // LOCK = DISABLE, UNLOCK = ENABLE
    case accountsTypes.lock.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case accountsTypes.lock.success: {
      const {account}=action.payload
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        errors: [],
        must_redirect: false,
        accounts: state.accounts.map( item => {
          if (item.id === account.id) {
            return account
          } else {
            return item
          }
        })
      }
    }

    case accountsTypes.lock.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // UPDATE
    case accountsTypes.update.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case accountsTypes.update.success: {
      const {account}=action.payload
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        errors: [],
        accounts: state.accounts.map( item => {
          if (item.id === account.id) {
            return account
          } else {
            return item
          }
        })
      }
    }

    case accountsTypes.update.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // DELETE
    case accountsTypes.destroy.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case accountsTypes.destroy.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        errors: [],
        accounts: action.payload.accounts,
        pagination: action.payload.pagination
      }
    }

    case accountsTypes.destroy.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // CREATE
    case accountsTypes.create.init: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        must_redirect: false,
        errors: []
      }
    }

    case accountsTypes.create.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        must_redirect: false,
        errors: []
      }
    }

    case accountsTypes.create.success: {
      toast({
        html: "Account created successfully"
      })
      return {
        ...state,
        fetching: false,
        fetched: true,
        must_redirect: true,
        accounts: action.payload.accounts,
        pagination: action.payload.pagination,
        errors: []
      }
    }

    case accountsTypes.create.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        must_redirect: false,
        errors: action.payload
      }
    }


    default: {
      return {...state};
    }
  }

}



// WEBPACK FOOTER //
// ./src/js/reducers/accountsReducer.js